import { useNavigate } from 'react-router-dom'

export const APP_ROUTES = {
  home: '/',
  login: '/login',
  logout: '/logout',
  dashboard: '/dashboard',
  shop: '/shop',
  guidelines: '/guidelines',
  onboarding: '/onboarding',
  subscriptionServices: '/subscription-services',
  buyout: '/buyout',
  myAssets: '/my-assets',
  hardware: '/hardware',
  resale: '/resale',
  resaleListing: '/resale/listing/:listingId',
  cart: '/cart',
  ecomPolicyList: '/ecom-policy',
  ecomPolicy: ':ecomPolicyId',
  ecomPolicyWizard: 'wizard',
  ecomPolicyOrderList: '/ecom-orders',
  ecomPolicyOrder: '/ecom-orders/:orderId',
  ecomPolicyGreenpoolOrder: '/ecom-orders/greenpool-order/:orderId',
  activities: '/activities',
}

export const useGoToDashboard = () => {
  const navigate = useNavigate()

  return () => navigate(APP_ROUTES.dashboard)
}
